import { Link, useLocation } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function Header() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  if (isAdmin) return null;

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/80 border-b border-slate-100"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-sky-600 text-white">
            <Sparkles className="h-5 w-5" />
          </span>
          <span className="font-display text-xl font-extrabold tracking-tight text-slate-900">
            Shine <span className="text-sky-600">Express</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-slate-600">
          <a href="#services" onClick={scrollTo("services")} className="hover:text-sky-600 transition" data-testid="nav-services">Services</a>
          <a href="#why" onClick={scrollTo("why")} className="hover:text-sky-600 transition" data-testid="nav-why">Why Us</a>
          <a href="#testimonials" onClick={scrollTo("testimonials")} className="hover:text-sky-600 transition" data-testid="nav-testimonials">Reviews</a>
          <a href="#contact" onClick={scrollTo("contact")} className="hover:text-sky-600 transition" data-testid="nav-contact">Contact</a>
        </nav>

        <a
          href="#booking"
          onClick={scrollTo("booking")}
          className="btn-primary inline-flex items-center rounded-full px-5 py-2.5 text-sm font-semibold"
          data-testid="header-cta-quote"
        >
          Get a Quote
        </a>
      </div>
    </header>
  );
}
